import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteCardAccountCreate,
  NoteCardAccountCreateVariables,
} from './__generated__/NoteCardAccountCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_CARD_ACCOUNT_CREATE from './NoteCardAccountCreate.graphql';

type CardAccountNotesSectionProps = Pick<
  NotesSectionProps,
  'listRefreshRequest'
> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const CardAccountNotesSection: React.FC<
  CardAccountNotesSectionProps
> = ({ id, data, loading, listRefreshRequest }) => {
  return (
    <GenericNotesSection<
      any,
      NoteCardAccountCreate, // TMutationResult
      NoteCardAccountCreateVariables // TMutationVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_CARD_ACCOUNT_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
